"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable complexity */
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const useLocale_1 = require("hooks/useLocale");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const PasswordIcon = ({ isShowPasswordValue, onClick }) => {
    return (react_1.default.createElement(SVGIcon_1.default, { iconName: isShowPasswordValue ? 'icon-remove_red_eye' : 'icon-disabled_red_eye', fillColor: "var(--n-600)", onClick: onClick, size: isShowPasswordValue ? 20 : 24, customClass: `absolute ${isShowPasswordValue ? 'right-[14px]' : 'right-[12px]'} ` }));
};
const CalendarIcon = ({ disabled }) => {
    return (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-calendar_today", fillColor: disabled ? 'var(--n-600)' : 'var(--base-600)', size: 24, customClass: "absolute right-[8px]" }));
};
const InputField = react_1.default.forwardRef(({ handleChange, handleKeyPress, styledInputClass = 'styled-input', showBorderOnHover, inputClass, bgColorClass, disabled, readOnly, inputError, cancelIcon, htmlFor, label, className = '', type, search, positionSearch = 'absolute left-8 top-[50%] -translate-y-1/2 transform', inputClassFooter = '', password, value, defaultValue, dataCy, autoFocus, onKeyDown, onBlur, onClick, autoComplete, min, maxLength, onFocus, useAutoGrowInput, onMouseDown, onMouseUp, calendar, cancelChanges, placeholder }, ref) => {
    const [offsetWidth, setOffSetWidth] = (0, react_1.useState)(0);
    const spanRef = (0, react_1.useRef)(null);
    const [isShowPasswordValue, setIsShowPasswordValue] = (0, react_1.useState)(false);
    const { setBothLocale } = (0, useLocale_1.useLocale)();
    const typeInputField = isShowPasswordValue ? 'text' : 'password';
    const _onChange = (e) => {
        if (!disabled && !readOnly) {
            handleChange?.(e);
        }
    };
    const _onKeyPress = (e) => {
        handleKeyPress && handleKeyPress(e);
    };
    const inputCN = (0, classnames_template_literals_1.default)(`
      ${styledInputClass}
      ${showBorderOnHover && 'show-border-on-hover'}
      ${inputClass && inputClass}
      ${bgColorClass ? bgColorClass : 'bg-n-000'}
      ${(disabled || readOnly) &&
        'border-gray cursor-not-allowed border border-solid bg-n-100 text-n-800'}
      ${inputError && 'input-error'}
      ${(cancelIcon || password) && 'pr-[40px]'}
      ${search && 'pl-[38px]'}
    `);
    (0, react_1.useEffect)(() => {
        setOffSetWidth(spanRef?.current?.offsetWidth ?? 0);
    }, [spanRef?.current?.offsetWidth]);
    return (react_1.default.createElement("div", { className: `container-input ${className}` },
        label && (react_1.default.createElement("label", { className: "styled-label", htmlFor: htmlFor }, setBothLocale(label))),
        search && (react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--base-600)", iconName: "icon-search", customClass: positionSearch })),
        react_1.default.createElement("div", { className: `flex items-center ${inputClassFooter}` },
            react_1.default.createElement("input", { ref: ref, className: inputCN, name: htmlFor, onChange: _onChange, onKeyUp: _onKeyPress, id: htmlFor, type: password ? typeInputField : type, value: value, defaultValue: defaultValue, placeholder: setBothLocale(placeholder), "data-cy": dataCy, disabled: disabled, readOnly: readOnly, autoFocus: autoFocus, onKeyDown: onKeyDown, onBlur: onBlur, onClick: onClick, autoComplete: autoComplete, min: min, maxLength: maxLength, onFocus: onFocus, style: {
                    width: useAutoGrowInput ? `${offsetWidth + 8}px` : '100%'
                }, onMouseDown: onMouseDown, onMouseUp: onMouseUp }),
            useAutoGrowInput && (react_1.default.createElement("span", { ref: spanRef, className: `invisible ${inputCN} h-0 w-fit border-y-0 py-0` }, value)),
            password && (react_1.default.createElement(PasswordIcon, { isShowPasswordValue: isShowPasswordValue, onClick: () => setIsShowPasswordValue(!isShowPasswordValue) })),
            calendar && react_1.default.createElement(CalendarIcon, { disabled: disabled || readOnly }),
            cancelIcon && cancelChanges && (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-cancel", fillColor: "var(--n-600)", onClick: () => cancelChanges(), size: 24, disabled: disabled, customClass: "absolute right-[8px]" })))));
});
InputField.displayName = 'InputField';
exports.default = InputField;
